import React from "react";
import {
  Box, Typography, Grid, Switch, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const REGISTRAZIONE_OPTIONS = [
  { id: "cliente", label: "A carico cliente" },
  { id: "algores", label: "A carico Algores" },
];

export default function SezioneRegistrazione({ form, toggleMultiple }) {
  return (
    <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#FAEEDA" }}>
        <Typography fontWeight="bold">Registrazione evento</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" mb={1}>
              Registrazione video
            </Typography>
            <Box display="flex" gap={2}>
              {REGISTRAZIONE_OPTIONS.map((opt) => (
                <FormControlLabel key={opt.id}
                  control={<Switch
                    checked={(form.registrazioneVideo || []).includes(opt.id)}
                    onChange={() => toggleMultiple("registrazioneVideo", opt.id)} />}
                  label={opt.label} />
              ))}
            </Box>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}